"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Checks if the Snowplow tracker exists by seeing if it is saved to the window
 */
const isReady = () => typeof window !== 'undefined' && window.snowplow !== undefined;
exports.default = isReady;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiaW5kZXguanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi8uLi9zcmMvdXRpbHMvaXNSZWFkeS9pbmRleC50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOztBQUFBOztHQUVHO0FBQ0gsTUFBTSxPQUFPLEdBQUcsR0FBWSxFQUFFLENBQUMsT0FBTyxNQUFNLEtBQUssV0FBVyxJQUFJLE1BQU0sQ0FBQyxRQUFRLEtBQUssU0FBUyxDQUFDO0FBRTlGLGtCQUFlLE9BQU8sQ0FBQyJ9


// WEBPACK FOOTER //
// ../../../../src/utils/isReady/index.ts